const state = {
    cncd: {
        filter: {
            year:new Date().getFullYear(),
            emulation_group_id:0,
        }
    },
    ldcd: {
        filter: {
            year:new Date().getFullYear(),
            currentMonth:new Date().getMonth()+1,
            full_name:"",
            emulation_group_id:0,
            approver_status:1000
        }
    },
    vpth: {
        filter: {
            year:new Date().getFullYear(),
            currentMonth:new Date().getMonth()+1,
            full_name:"",
            department_id:"0",
            emulation_group_id:0
        }
    }

}

const actions = {
    saveCNCDSearchFilter ({commit}, payload) {
        const { filter } = payload;
        commit('CNCD_FILTERS', filter);
    },
    saveLDCDSearchFilter ({commit}, payload) {
        const { filter } = payload;
        commit('LDCD_FILTERS', filter);
    },
    saveVPTHSearchFilter ({commit}, payload) {
        const { filter } = payload;
        commit('VPTH_FILTERS', filter);
    }
}

const mutations = {
    CNCD_FILTERS: (state, response) => {
        state.cncd.filter = {...response};
    },
    LDCD_FILTERS: (state, response) => {
        state.ldcd.filter = {...response};
    },
    VPTH_FILTERS: (state, response) => {
        state.vpth.filter = {...response};
    }
}

const getters = {
    filterCNCD: state => {
        return state.cncd.filter;
    },
    filterLDCD: state => {
        return state.ldcd.filter;
    },
    filterVPTH: state => {
        return state.vpth.filter;
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};